import { connect } from 'react-redux';
import { openModal } from 'components/Modal';
import { selectActiveVenueId, selectVenueClasses } from 'selectors/general';
import { selectLocaleData } from 'selectors/locale-data';
import { publishSchedules, generateSchedules } from '../ClasstivityScheduler.saga';
import { clearNewScheduleInstances, resetNewClassId } from '../ClasstivityScheduler.reducers';
import { selectNewScheduleInstancesLength, selectNewClassId } from '../ClasstivityScheduler.selectors';

import ClasstivitySchedulerForm from './ClasstivitySchedulerForm';

export const mapStateToProps = (state, ownProps) => {
  const venueId = selectActiveVenueId(state);
  const classes = selectVenueClasses(state, venueId);
  const { startWeekOn } = selectLocaleData(state);
  const newSchedulesCount = selectNewScheduleInstancesLength(state);
  const newClassId = selectNewClassId(state);

  return {
    ...ownProps,
    startWeekOn,
    classes,
    newSchedulesCount,
    newClassId,
  };
};

const mapDispatchToProps = {
  onFormSubmit: (formData, formAsyncFns) => generateSchedules(formData, formAsyncFns),
  onPublishClick: () => publishSchedules(),
  onResetClick: clearNewScheduleInstances,
  onResetNewClassId: () => resetNewClassId(),
  openAddClassModal: () => openModal('AddClasstivityClassModal'),
};

export default connect(mapStateToProps, mapDispatchToProps)(ClasstivitySchedulerForm);
